import { createApi } from "@reduxjs/toolkit/dist/query/react";
import { transformSucessResponse, transformErrorResponse } from "../../utils/API/responseMiddleware";
import { encryptQueryString } from "../../utils/API/requestMiddleware";
// import { defautBaseQuery } from '../../utils/API/fetchBaseQuery';
import { customFetchBase } from '../../utils/API/fetchBaseQuery';

const positionAPI = createApi({
    reducerPath: 'positionAPI',
    baseQuery: customFetchBase,
    endpoints: (builder) => ({

        getPosition: builder.query({
            query: () => ({
                url: encryptQueryString(`/Position/GetPosition`),
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        getHRList: builder.query({
            query: () => ({
                url: encryptQueryString(`/Position/GetHRList`),
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

    })
})

export const { useLazyGetPositionQuery, useLazyGetHRListQuery } = positionAPI;

export default positionAPI;